export default () => ({
  toggleState: false,
  recordState: false
})
